import noop from 'lodash/noop';
import React from 'react';
import { PinCluster, MapPinView } from '@hotelplan/components.common.map-pin';
import FdrSRLMapProductCluster from 'fdr/components/local/fdr-srl-map/fdr-srl-map-product-cluster';
import { FdrProductPin } from 'fdr/components/local/fdr-srl-map/fdr-srl-map.types';

type Product = FdrProductPin;

interface IWishlistMapItemsProps {
  mapItems: Product[];
  onProductClusterClick?(products: Product[], cluster: PinCluster): void;
  onProductClick?(product: Product, pin: MapPinView<Product>): void;
  onClickOnSelectedPin?(): void;
}

const FdrWishlistMapItems: React.FC<IWishlistMapItemsProps> = props => {
  const {
    mapItems,
    onProductClusterClick = noop,
    onProductClick = noop,
    onClickOnSelectedPin,
  } = props;

  return (
    <FdrSRLMapProductCluster
      products={mapItems}
      onClusterClick={onProductClusterClick}
      onProductClick={onProductClick}
      onClickOnSelectedPin={onClickOnSelectedPin}
    />
  );
};

export default FdrWishlistMapItems;
